// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cognito_identity_pool_id": "eu-west-1:ea61165c-2123-476a-8278-574cfa620aab",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_M74fN5Oac",
    "aws_user_pools_web_client_id": "140fsadmlp68f5md2i3e98gnm4",
    "oauth": {},
    "aws_content_delivery_bucket": "gbkpulse-20190529220722-hostingbucket-dev",
    "aws_content_delivery_bucket_region": "eu-west-1",
    "aws_content_delivery_url": "https://d2tgcau2ozhu32.cloudfront.net",
    "aws_dynamodb_all_tables_region": "eu-west-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "test2-dev",
            "region": "eu-west-1"
        }
    ],
    "aws_cloud_logic_custom": [
        {
            "name": "gbkpulseapi",
            "endpoint": "https://0usg0no242.execute-api.eu-west-1.amazonaws.com/dev",
            "region": "eu-west-1"
        }
    ]
};


export default awsmobile;
